/** 차트 컬러 팔레트 — SVG attribute에 CSS var() 사용 불가하므로 hex 값으로 제공 */

export const CHART_COLORS = {
  primary: '#7c3aed',       // violet-600 (브랜드 기본)
  primaryLight: '#ede9fe',  // violet-100
  info: '#8b5cf6',          // violet-500
  infoLight: '#f5f3ff',     // violet-50
  success: '#22c55e',
  successLight: '#dcfce7',
  warning: '#f59e0b',
  warningLight: '#fef3c7',
  danger: '#ef4444',
  dangerLight: '#fee2e2',
  gray: '#94A3B8',
  grayLight: '#E2E8F0',
} as const

export const CHART_PALETTE = [
  '#7c3aed', // violet-600 (브랜드 기본)
  '#a78bfa', // violet-400
  '#22c55e', // emerald — 대비색 유지
  '#f59e0b', // amber — 대비색 유지
  '#ef4444', // rose — 대비색 유지
  '#c4b5fd', // violet-300
  '#6d28d9', // violet-700
  '#ec4899', // pink — 대비색 유지
  '#14b8a6', // teal — 대비색 유지
  '#f97316', // orange — 대비색 유지
] as const
